const COMMON_TITLES_DELIVERY = {
  estimatedFulfillmentLabel: 'ESTIMATED_DELIVERY_DATE',
  method: 'MO_SHIPPINGMETHOD_WITHOUT_COLON',
  instructions: 'SHIP_SHIPPING_INSTRUCTIONS',
  address: 'MO_SHIPPINGADDRESS_WITHOUT_COLON',
  specialInstruction: 'MO_SHIPPING_SPECIAL_INSTRUCTIONS_WITHOUT_COLON'
};
const COMMON_METHODS = {
  method: 'method',
  instructions: 'shippingInstructions',
  address: 'shippingAddress',
  specialInstruction: 'specialnstructions'
};

export const ORDER_MAP_TITLE_BY_TYPE_DELIVERY = {
  shopOnline: COMMON_TITLES_DELIVERY,
  delivery: COMMON_TITLES_DELIVERY,
  pickup: {
    estimatedFulfillmentLabel: 'ESTIMATED_PICKUP_DATE',
    method: 'CHECKOUT_PICKUP_METHOD',
    instructions: 'CAT_SHOPPING_PREFERENCES_PICKUP_INSTRUCTION',
    address: 'MO_STORE_LOCATION',
    specialInstruction: 'MO_SHIPPING_SPECIAL_INSTRUCTIONS_WITHOUT_COLON'
  }
};

export const ORDER_DELIVERY_METHODS_INFORMATION = {
  shopOnline: COMMON_METHODS,
  delivery: COMMON_METHODS,
  pickup: {
    method: 'method',
    instructions: 'instructions',
    address: 'storeAddress',
    specialInstruction: 'specialnstructions'
  },
  dropBox: {
    method: 'method',
    instructions: 'dropBoxInstructions',
    address: 'dropBoxAddress',
    specialInstruction: 'specialnstructions'
  }
};

export const ORDER_TABLE_TYPE = {
  pending: 'pending',
  shipping: 'shipping',
  pickup: 'pickup',
  partialPickup: 'partialPickup'
};

export const PICK_UP_TYPE = 'pickup';
export const PARTIAL_PICK_UP_TYPE = 'pickup';
export const DELIVERY_TYPE = 'delivery';
export const DROP_BOX_TYPE = 'dropBox';
export const SHOP_ONLINE_TYPE = 'shopOnline';

export const PARTIAL_PICKUP_READY_STATUS = 'PA';
